<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <!-- <ComingSoon /> -->
      <div class="statics mt-4">
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-12"
            v-for="(value, key) in statics"
            :key="'i' + key"
          >
            <div class="box">
              <div class="icon">
                <i v-if="key === 'clients'" class="fas fa-users"></i>
                <i v-if="key === 'providers'" class="fas fa-users"></i>
                <i v-if="key === 'admins'" class="fas fa-users"></i>
                <i v-if="key === 'activeOrders'" class="fas fa-store"></i>
                <i v-if="key === 'completedOrders'" class="fas fa-store"></i>
                <i v-if="key === 'canceledOrders'" class="fas fa-store"></i>
                <i
                  v-if="key === 'totalProfit'"
                  class="fas fa-money-check-alt"
                ></i>
                <i v-if="key === 'total_new_packages'" class="fas fa-box"></i>
                <i
                  v-if="key === 'total_on_the_way_packages'"
                  class="fas fa-shipping-fast"
                ></i>
                <i
                  v-if="key === 'total_completed_today_packages'"
                  class="fas fa-box-open"
                ></i>
                <i
                  v-if="key === 'total_returned_today_packages'"
                  class="fas fa-undo-alt"
                ></i>
              </div>

              <div class="info_box">
                <span v-if="key == 'clients'">{{
                  $t("PLACEHOLDERS.clients_static")
                }}</span>
                <span v-if="key == 'providers'">{{
                  $t("PLACEHOLDERS.providers_static")
                }}</span>
                <span v-if="key == 'admins'">{{
                  $t("PLACEHOLDERS.admins_static")
                }}</span>
                <span v-if="key == 'activeOrders'">{{
                  $t("PLACEHOLDERS.activeOrders_static")
                }}</span>
                <span v-if="key == 'completedOrders'">{{
                  $t("PLACEHOLDERS.completedOrders_static")
                }}</span>
                <span v-if="key == 'canceledOrders'">{{
                  $t("PLACEHOLDERS.canceledOrders_static")
                }}</span>
                <span v-if="key == 'totalProfit'">{{
                  $t("PLACEHOLDERS.totalProfit_static")
                }}</span>
                <span v-if="key == 'total_new_packages'">{{
                  $t("PLACEHOLDERS.total_new_packages_static")
                }}</span>
                <span v-if="key == 'total_on_the_way_packages'">{{
                  $t("PLACEHOLDERS.total_on_the_way_packages_static")
                }}</span>
                <span v-if="key == 'total_completed_today_packages'">{{
                  $t("PLACEHOLDERS.total_completed_today_packages_static")
                }}</span>
                <span v-if="key == 'total_returned_today_packages'">{{
                  $t("PLACEHOLDERS.total_returned_today_packages_static")
                }}</span>

                <p class="number_box">{{ value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: [],
    };
  },

  methods: {
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "home",
        });

        // console.log("All Data ==>", res.data.data);
        this.statics = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
.show_all_content_wrapper {
  .statics {
    .box {
      background: #ef3405;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      //cursor: pointer;
      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #ef3405;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
